// @flow
import * as React from 'react';

import setHocDisplayName from '@zapier/common-utils/src/setHocDisplayName';

import type { ComponentType } from 'react';

function withMapProps<P: Object, M: Object>(
  Component: ComponentType<P>,
  map: M => P
): ComponentType<M> {
  const WithMapProps = function WithMapProps(props: M) {
    const mappedProps = map(props);
    return <Component {...mappedProps} />;
  };
  setHocDisplayName(WithMapProps, Component);
  return React.memo(WithMapProps);
}

export default withMapProps;
